import { Link } from "react-router-dom"

const Headerdash = () =>
{
    let a = async () => {
        let x;
        try {
            x = await fetch('https://api.voicecoach.net/ping', {
                credentials:'include', headers: {'Content-type':'application/json'}
            });
        } catch (e) {
            console.log(e);
            alert('Something is wrong with the upstream server. Please notify tech.');
            window.location.href = "/karma";
        }
        if (!x.ok) {
            window.location.href = "/karma";
        }
        return 'r';
    }
    a();
    return <header className="d-flex text-bg-vc py-3">
    <div className="container">
        <div className="row">
            <div className="col-2 col-lg-2">
        <a href="/">
            <h1 className="invisible h0">Voice Coach for Podcast in Sydney</h1>
            <img src="/img/logo.svg" className="w-75" alt="Voice Coach logo" />
        </a>
        </div>
        <div className="col-10 col-lg-10 d-flex">
        <nav className="navbar navbar-expand-lg">
            <ul role="navigation" className="navbar-nav md-align-items-center">
                <li className="nav-item mx-2 py-1">
                    <Link to="/edit/home">Edit Home</Link>
                </li>
                <li className="nav-item mx-2 py-1">
                    <Link to="/edit/course-details">Edit Course Details</Link>
                </li>
                <li className="nav-item mx-2 py-1">
                    <Link to="/edit/about">Edit About Us</Link>
                </li>
                <li className="nav-item mx-2 py-1">
                    <Link to="/edit/about-you">Edit About You</Link>
                </li>
                <li className="nav-item mx-2 py-1">
                    <Link to="/edit/legal/privacy">Edit Privacy</Link>
                </li>
                <li className="nav-item mx-2 py-1">
                    <Link to="/edit/legal/terms">Edit Terms</Link>
                </li>
                <li className="nav-item mx-2 py-1">
                    <Link to="/edit/booking">Look at Bookings</Link>
                </li>
                <li className="nav-item mx-2 py-1">
                    <Link to="/edit/subs">Check subscribers</Link>
                </li>
            </ul>
        </nav>
        </div>
        </div>
    </div>
</header>
}
export default Headerdash